<div class="visitor-div">
    <div class="space-name-container">
            <img class="img-logo" alt="SmarterPlanLogo" src="../../../../../assets/images/logos/SP_Museum_dark.svg">
            <!-- <button class="btn-header" *ngIf="isGuide"  [routerLink]="['/dashboard']">{{'Dashboard' | translate }}</button> -->
    </div>
    <museum-user-menu [user]="currentUser" [isGuide]="isGuide" style="margin-left: auto;"></museum-user-menu>
</div>
